import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import * as classNames from 'classnames';
var Steps = /** @class */ (function (_super) {
    __extends(Steps, _super);
    function Steps() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isStepDisabled = function (step) {
            var _a = _this.props, steps = _a.steps, currentStepKey = _a.currentStepKey;
            var stepKeys = steps.map(function (s) { return s.key; });
            return stepKeys.indexOf(currentStepKey) <= stepKeys.indexOf(step.key);
        };
        _this.renderStep = function (step, idx) {
            var _a = _this.props, steps = _a.steps, onChange = _a.onChange;
            var isDisabled = _this.isStepDisabled(step);
            var isSelected = step.key === _this.props.currentStepKey;
            var classes = classNames('step-container', {
                selected: isSelected,
                disabled: !isSelected && isDisabled,
                checked: !isSelected && !isDisabled,
                short: steps.length < 3 && idx >= (steps.length - 1)
            });
            var maybeLine = idx < (steps.length - 1) ? React.createElement("span", { className: 'solid-line' }) : null;
            var onClick = function () {
                if (!isSelected && !isDisabled) {
                    onChange(step);
                }
            };
            return (React.createElement("span", { key: idx, className: classes, "data-key": step.key },
                React.createElement("span", { key: idx, className: 'step-inner-wrapper' },
                    React.createElement("div", { className: 'step-idx', onClick: onClick }, idx + 1),
                    maybeLine),
                React.createElement("div", { className: 'step-label' }, step.label)));
        };
        return _this;
    }
    Steps.prototype.render = function () {
        var _this = this;
        var steps = this.props.steps;
        var className = namespacedClassnames('steps');
        var stepsComp = steps.map(function (step, idx) { return _this.renderStep(step, idx); });
        return (React.createElement("div", { className: className }, stepsComp));
    };
    return Steps;
}(React.PureComponent));
export { Steps };
//# sourceMappingURL=steps.js.map